import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsServiceService {
  constructor(private http: HttpClient) { }


  userByID(data:any){
    return this.http.post(environment.apiUrl + "userInformation/get/byId" , data)
  }


}
